import React, { useState, useEffect, useRef } from 'react';
import FilterLayoutDragDrop from '../CustomFilter/FilterLayoutDragDrop';
import { useSelector, useDispatch } from "react-redux";
import {
    setCustomFilterOptions
} from "../../../../../StateManagement/actions";
import "../../../../Shared/CommonTab/common-tabs.css"
import "../../../History/Manage.css"
export default function CustomColumnLayout({
    selectedLanguage,
    handlerCustomColumnLayoutCancel,
    handlerCustomColumnLayoutConfirm,
    sortedColumns,
    setParentAlertMsg,
    timeZoneAbbrevation,
    customFilterOptionsArray,
    setCustomColumnLayoutFlag,
    clearFilters
}) {
    const [checkedAvailable, setCheckedAvailable] = useState([]);
    const [checkedSelected, setCheckedSelected] = useState([]);
    const [available, setAvailable] = useState([]);
    const [selected, setSelected] = useState([]);
    const [initialState, setInitialState] = useState([]);
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState("column");
    const filterRef = useRef();
    const toggleChecked = (listType, name) => {
        const checked = listType === 'available' ? checkedAvailable : checkedSelected;
        const setChecked = listType === 'available' ? setCheckedAvailable : setCheckedSelected;

        if (checked.includes(name)) {
            setChecked(checked.filter((n) => n !== name));
        } else {
            setChecked([...checked, name]);
        }
    };

    const [draggingItem, setDraggingItem] = useState(null);
    const [dragSourceList, setDragSourceList] = useState(null);

    const handleDragStart = (item, sourceListName) => {
        setDraggingItem(item);
        setDragSourceList(sourceListName);
    };
    function handlerCustomColumnRestore() {
        if (activeTab == "filter") {
            filterRef.current?.restoreDefaults();
        } else {
            const defaultGridColumns = [
                {
                    name: "checkbox",
                    class: 'w-5p res-pr-0 pe-0',
                    classData: "w-5p text-start",
                    classTrack: 'w-5p res-pr-0 pe-0',
                    fixed: true,
                    active: true,
                    order: 0.5
                },
                {
                    name: "type",
                    label: selectedLanguage.LstLanguageCodes.UI_Type,
                    class: "w-4p res-pl-3 res-pl-0 pl-2px text-center",
                    classData: "w-4p text-center grid-border-left",
                    classTrack: "w-6p res-pl-3 res-pl-0 pl-2px",
                    fixed: true,
                    active: true,
                    order: 0.6
                },
                {
                    name: "created",
                    label: selectedLanguage.LstLanguageCodes.UI_Created + " " + "(" + timeZoneAbbrevation + ")",
                    labelTab: selectedLanguage.LstLanguageCodes.UI_Created,
                    class: "w-10p pl-5px ",
                    classData: "text-start w-10p grid-border-left",
                    classTrack: "w-10p pl-5px",
                    sortable: true,
                    active: true,
                    order: 3
                },
                {
                    name: "subjectdescription",
                    class: "w-13p pl-5px",
                    classData: "text-start w-13p grid-border-left",
                    classTrack: "w-15p pl-5px",
                    label: `${selectedLanguage.LstLanguageCodes.UI_Subject}/${selectedLanguage.LstLanguageCodes.UI_Description}`,
                    active: true,
                    order: 4
                },
                {
                    name: "documentname",
                    class: "w-13p pl-5px",
                    classData: "text-start w-13p grid-border-left",
                    classTrack: "w-14p pl-5px",
                    label: selectedLanguage.LstLanguageCodes.UI_DocumentName,
                    active: true,
                    order: 5
                },
                {
                    name: "initialreaders",
                    class: "w-14p pl-5px",
                    classData: "text-start w-14p grid-border-left",
                    classTrack: "w-14p pl-5px",
                    label: selectedLanguage.LstLanguageCodes.UI_InitialReaders,
                    active: true,
                    order: 6
                },
                {
                    name: "dayssincelastview",
                    class: "w-12p pl-5px text-center",
                    classData: "text-start w-12p grid-border-left",
                    classTrack: "w-12p pl-5px text-center",
                    label: selectedLanguage.LstLanguageCodes.UI_DaysSinceLastView,
                    sortable: true,
                    active: true,
                    order: 7
                },
                {
                    name: "status",
                    class: "w-10p pl-5px text-center",
                    classData: "text-center w-10p  all-tdBtn grid-border-left",
                    classTrack: "w-10p pl-5px text-center",
                    label: selectedLanguage.LstLanguageCodes.UI_Status,
                    active: true,
                    order: 8
                },
                {
                    name: "accesscontrol",
                    class: "w-12p text-center pl-5px",
                    classData: "text-center w-12p  all-tdBtn grid-border-left",
                    classTrack: "w-12p text-center pl-5px",
                    label: selectedLanguage.LstLanguageCodes.UI_AccessControl,
                    active: true,
                    order: 9
                },
                {
                    name: "documentid",
                    class: "w-10p pl-5px",
                    classData: "text-start w-10p grid-border-left",
                    classTrack: "w-12p pl-5px",
                    label: selectedLanguage.LstLanguageCodes.UI_DocumentID,
                    active: false,
                    order: 10
                },
                {
                    name: "owner",
                    class: "w-12p pl-5px",
                    classData: "text-start w-12p grid-border-left",
                    classTrack: "w-12p pl-5px",
                    label: selectedLanguage.LstLanguageCodes.UI_Owner,
                    active: false,
                    order: 11,
                },
                {
                    name: "pages",
                    class: "w-10p text-center pl-5px",
                    classData: "text-center w-10p grid-border-left",
                    classTrack: "w-12p text-center pl-5px",
                    label: selectedLanguage.LstLanguageCodes.UI_Pages,
                    active: false,
                    order: 14
                },
                {
                    name: "launches",
                    class: "w-10p pl-5px",
                    classData: "w-10p text-start pl-5px grid-border-left",
                    classTrack: "w-10p text-start pl-5px",
                    label: selectedLanguage.LstLanguageCodes.UI_Launches + " " + "(" + timeZoneAbbrevation + ")",
                    labelTab: selectedLanguage.LstLanguageCodes.UI_Launches,
                    active: false,
                    order: 15
                },
                {
                    name: "expires",
                    class: "w-10p pl-5px",
                    classData: "w-10p text-start pl-5px grid-border-left",
                    classTrack: "w-10p text-start pl-5px",
                    label: selectedLanguage.LstLanguageCodes.UI_Expires + " " + "(" + timeZoneAbbrevation + ")",
                    labelTab: selectedLanguage.LstLanguageCodes.UI_Expires,
                    active: false,
                    order: 16
                }
            ];
            columnsToLists(defaultGridColumns, 1);
        }
    }
    useEffect(() => {
        columnsToLists(sortedColumns, 0);
    }, [sortedColumns]);
    function columnsToLists(lSortedColumns, intialStat) {
        if (Array.isArray(lSortedColumns)) {
            const selectedColumns = lSortedColumns
                .filter((record) => record.active)
                .sort((a, b) => a.order - b.order);
            const unselectedColumns = lSortedColumns
                .filter((record) => !record.active)
                .sort((a, b) => a.order - b.order);

            setAvailable(unselectedColumns);
            setSelected(selectedColumns);
        }
        if (intialStat == 0) {
            setInitialState(
                lSortedColumns.map((col) => ({
                    Name: col.name,
                    order: col.order,
                    active: col.active,
                    label: col.label,
                }))
            );
        }
    }

    const handleDrop = (targetListName, targetIndex = null) => {
        if (!draggingItem || !dragSourceList) return;

        const moveItem = (fromList, toList, setFromList, setToList) => {
            const itemIndex = fromList.findIndex((i) => i.name === draggingItem.name);
            if (itemIndex === -1) return;

            const updatedFrom = [...fromList];
            updatedFrom.splice(itemIndex, 1);

            const updatedTo = [...toList];
            const newItem = {
                ...draggingItem,
                active: targetListName === 'selected'
            };

            if (targetIndex === null || targetIndex >= updatedTo.length) {
                updatedTo.push(newItem);
            } else {
                updatedTo.splice(targetIndex, 0, newItem);
            }

            // Conditionally update order for items in the 'from' list
            updatedFrom.forEach((item, idx) => {
                if (item.name !== "type" && item.name !== "checkbox") {
                    item.order = idx + 1;
                }
            });
            // Conditionally update order for items in the 'to' list
            updatedTo.forEach((item, idx) => {
                if (item.name !== "type" && item.name !== "checkbox") {
                    item.order = idx + 1;
                }
            });

            setFromList(updatedFrom);
            setToList(updatedTo);
        };

        const sourceList = dragSourceList === 'available' ? available : selected;
        const targetList = targetListName === 'available' ? available : selected;

        const setSource = dragSourceList === 'available' ? setAvailable : setSelected;
        const setTarget = targetListName === 'available' ? setAvailable : setSelected;

        if (dragSourceList !== targetListName) {
            moveItem(sourceList, targetList, setSource, setTarget);
            if (dragSourceList === "available") {
                setCheckedAvailable(prev =>
                    prev.filter(name => name !== draggingItem.name)
                );
            } else {
                setCheckedSelected(prev =>
                    prev.filter(name => name !== draggingItem.name)
                );
            }
        } else {
            const index = sourceList.findIndex((i) => i.name === draggingItem.name);
            if (index === -1 || index === targetIndex) return;

            const updated = [...sourceList];
            updated.splice(index, 1);
            updated.splice(targetIndex, 0, draggingItem);

            // Conditionally update order for items in the same list
            updated.forEach((item, idx) => {
                if (item.name !== "type" && item.name !== "checkbox") {
                    item.order = idx + 1;
                }
            });
            setSource(updated);
        }

        setDraggingItem(null);
        setDragSourceList(null);
    };

    const handleSave = async () => {
        const responce = await filterRef?.current?.saveCustomFilter();
        if (responce?.message) {
            setParentAlertMsg(responce.message);
            return;
        }
        dispatch(setCustomFilterOptions(responce.customFilterOptions))
        console.log("Filters saved successfully");
        if (selected.length === 8 || selected.length === 9) {
            const combined = [...selected, ...available].map((item, idx) => ({
                ...item,
                order: (item.name === "type" || item.name === "checkbox") ? item.order : idx + 1,
                active: selected.some((s) => s.name === item.name),
            }));

            // Compare with initial state
            const hasChanges = combined.some((item) => {
                const initial = initialState.find(i => i.Name === item.name);
                return !initial ||
                    initial.active !== item.active ||
                    initial.order !== item.order;
            });
            handlerCustomColumnLayoutConfirm(combined, hasChanges);
        } else {
            if (selected.length < 8) {
                setParentAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectMinSix);
                return;
            }
            else if (selected.length > 9) {
                setParentAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectMaxSeven);
                return;
            }
        }

        setCustomColumnLayoutFlag();
    };

    const moveCheckedItems = (fromListType) => {
        const fromList = fromListType === 'available' ? available : selected;
        const toList = fromListType === 'available' ? selected : available;
        const setFrom = fromListType === 'available' ? setAvailable : setSelected;
        const setTo = fromListType === 'available' ? setSelected : setAvailable;
        const checked = fromListType === 'available' ? checkedAvailable : checkedSelected;
        const setChecked = fromListType === 'available' ? setCheckedAvailable : setCheckedSelected;

        const itemsToMove = fromList.filter((item) => checked.includes(item.name));
        const updatedFrom = fromList.filter((item) => !checked.includes(item.name));
        if (itemsToMove.length <= 0) {
            setParentAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOne);
            return;
        }
        const updatedTo = [
            ...toList,
            ...itemsToMove.map((i) => ({
                ...i,
                active: fromListType === 'available'
            })),
        ];

        // Conditionally update order for items in the 'from' list
        updatedFrom.forEach((item, idx) => {
            if (item.name !== "type" && item.name !== "checkbox") {
                item.order = idx + 1;
            }
        });
        // Conditionally update order for items in the 'to' list
        updatedTo.forEach((item, idx) => {
            if (item.name !== "type" && item.name !== "checkbox") {
                item.order = idx + 1;
            }
        });

        setFrom(updatedFrom);
        setTo(updatedTo);
        setChecked([]);
    };
    const shouldDisableButton = (fromListType) => {
        const checked = fromListType === 'available' ? checkedAvailable : checkedSelected;
        return !checked || checked.length === 0;
    };
    const renderList = (items, listName) => {
        const checked = listName === 'available' ? checkedAvailable : checkedSelected;

        // For moving single item up/down within selected list:
        // These functions are currently not used, but keep the conditional logic if you enable them later
        const moveItemUp = (index) => {
            if (index === 0) return;
            const newItems = [...items];
            [newItems[index - 1], newItems[index]] = [newItems[index], newItems[index - 1]];
            newItems.forEach((item, idx) => {
                if (item.name !== "type" && item.name !== "checkbox") {
                    item.order = idx + 1;
                }
            });
            if (listName === 'selected') setSelected(newItems);
            else setAvailable(newItems);
        };

        const moveItemDown = (index) => {
            if (index === items.length - 1) return;
            const newItems = [...items];
            [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]];
            newItems.forEach((item, idx) => {
                if (item.name !== "type" && item.name !== "checkbox") {
                    item.order = idx + 1;
                }
            });
            if (listName === 'selected') setSelected(newItems);
            else setAvailable(newItems);
        };

        return (
            <div
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => handleDrop(listName)}
                style={{
                    border: '1px solid #ccc',
                    padding: 10,
                    minWidth: 300,
                    maxHeight: 400,
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4,
                }}
            >
                <h4>{listName === "available" ? selectedLanguage.LstLanguageCodes.UI_AvailableColumns : selectedLanguage.LstLanguageCodes.UI_SelectedColumns}</h4>

                {items.filter(x => x.name !== "type" && x.name !== "checkbox").length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '10px', color: '#888' }}>
                        No columns
                    </div>
                ) : (
                    items.map((item, index) => {
                        const isChecked = checked.includes(item.name);
                        return (
                            (item.label && item.name !== "type" && item.name !== "checkbox") && // Added checkbox here to filter from rendering
                            <div
                                key={item.name}
                                draggable
                                onDragStart={() => handleDragStart(item, listName)}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={(e) => {
                                    e.stopPropagation();
                                    handleDrop(listName, index);
                                }}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    backgroundColor: isChecked ? '#d0ebff' : '#fafafa',
                                    padding: '6px 8px',
                                    borderRadius: 4,
                                    border: '1px solid #ddd'
                                }}
                                className='cursor-move'
                            >
                                <span
                                    style={{ flexGrow: 1, userSelect: 'none', display: 'flex', cursor: 'pointer' }}
                                    onClick={() => toggleChecked(listName, item.name)}
                                >
                                    <input
                                        type="checkbox"
                                        checked={isChecked}
                                        readOnly
                                        style={{ marginRight: 8, marginTop: 3, cursor: 'pointer', pointerEvents: 'none' }}
                                    />
                                    <span style={{ marginRight: '8px', cursor: 'move' }}>⋮⋮</span> <span> {item.label}</span>

                                </span>
                                {item.sortable && <div> <span className="material-icons sort-items-popup" > sync_alt </span> </div>}
                            </div>
                        );
                    })
                )}
            </div>
        );
    };


    return (
        <div
            className="modal"
            id="MoveFolder"
            style={{ display: 'block', backgroundColor: '#8080801c' }}
        >
            <div className="modal-dialog modal-dialog-centered modal-customelg modal-dailog-customcolumns">
                <div className="modal-content">

                    {/* Header */}
                    <div className="modal-header pb-1 flex-column align-items-start" style={{ borderBottom: '0' }}>
                        <h4 className="d-flex align-items-center text-danger fw-bold mb-2">
                            Custom Layout
                        </h4>

                        <div className="card border-0 w-100">
                            <ul className="nav nav-tabs common-tabs" style={{ borderBottom: "none", backgroundColor: '#ffffff' }}>
                                <li className="nav-item">
                                    <a
                                        href="#column"
                                        className={` nav-link manage-link boxshadow ${activeTab === "column" ? "active" : ""}`}
                                        style={{ boxShadow: 'none !important', borderBottom: '2px solid white', marginBottom: '0px' }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setActiveTab("column");
                                        }}
                                    >
                                        Column Layout
                                    </a>
                                </li>

                                <li className="nav-item">
                                    <a
                                        href="#filter"
                                        style={{ boxShadow: 'none !important', borderBottom: activeTab == "filter" ? "#bc272e" : '2px solid white', marginBottom: '0px' }}
                                        className={`boxshadow nav-link manage-link ${activeTab === "filter" ? "active" : ""}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setActiveTab("filter");
                                        }}
                                    >
                                        Filter Layout
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Body */}
                    <div className="modal-body justify-content-center" style={{ marginLeft: activeTab == "filter" ? "-19px" : "", marginTop: activeTab == "filter" ? "-19px" : "" }}>

                        {/* Custom Column Layout */}
                        {activeTab === "column" && (
                            <div style={{ display: 'flex', gap: 20 }}>
                                {renderList(available, 'available')}

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                        <button
                                            className="btn btn-primary btn-arrow-items"
                                            disabled={shouldDisableButton('available')}
                                            onClick={() => moveCheckedItems('available')}
                                        >
                                            <span className="material-icons">double_arrow</span>
                                        </button>

                                        <button
                                            className="btn btn-danger btn-arrow-items"
                                            disabled={shouldDisableButton('selected')}
                                            onClick={() => moveCheckedItems('selected')}
                                        >
                                            <span className="material-icons rotate-180">
                                                double_arrow
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                {renderList(selected, 'selected')}
                            </div>
                        )}

                        {/* Filter Layout */}
                        <div style={{ display: activeTab === "filter" ? "block" : "none" }}>
                            <FilterLayoutDragDrop
                                ref={filterRef}
                                sortedColumns={sortedColumns}
                                selectedLanguage={selectedLanguage}
                                customFilterOptionsArray={customFilterOptionsArray}
                                clearFilters={clearFilters}
                            />
                        </div>

                    </div>

                    {/* Footer */}
                    <div className="d-flex justify-content-between mb-3 me-3 mt-2">

                        <button
                            type="button"
                            className="btn btn-outline-success font-w600 ms-3 px-3 d-flex"
                            onClick={handlerCustomColumnRestore}
                        >
                            <span className="material-icons rotate-180 mr-5">
                                settings_backup_restore
                            </span>
                            {selectedLanguage.LstLanguageCodes.UI_RestoreToDefaults}
                        </button>

                        <div className="d-flex align-items-center ms-auto">
                            <button
                                type="button"
                                className="btn btn-danger px-4 me-1"
                                onClick={handlerCustomColumnLayoutCancel}
                            >
                                {selectedLanguage.LstLanguageCodes.UI_Cancel}
                            </button>

                            <button
                                type="button"
                                className="btn btn-primary px-4 ms-3"
                                onClick={handleSave}
                            >
                                {selectedLanguage.LstLanguageCodes.UI_Confirm}
                            </button>
                        </div>

                    </div>

                </div>
            </div>
        </div>

    );
}


